import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import { LocalizationMessages } from "../../localization/messages";
import { MenuActionCreators } from "../../redux/action-creators";
import { MenuSelectors } from "../../redux/selectors";
import Odds from "../Odds/Odds";
import classNames from "classnames";

const OddsMenuMobile = () => {
  const dispatch = useDispatch();
  const oddsMenuVisible = useSelector(MenuSelectors.oddsMenuVisible);
  const className = classNames("inner-mobile-menu odds-menu", {
    "drawer-show": oddsMenuVisible
  });

  const oddFormatClick = () => {
    dispatch(MenuActionCreators.hideOddsMenu());
  };

  return (
    <div className={className}>
      <p>
        <FormattedMessage {...LocalizationMessages.oddsFormatTitle} />
      </p>
      <Odds handleClick={oddFormatClick} />
    </div>
  );
};

export default OddsMenuMobile;
